import {Pillar} from '@primer/react-brand'
import {getPrimerIcon} from '@github-ui/swp-core/lib/utils/icons'
import {renderWithoutParagraphs} from '../../../utils'
import type {IconItem} from '../../../types'
import {SupportGrid} from './SupportGrid'

export function SupportPillars({items}: {items: IconItem[]}) {
  return items.map((item, index) => {
    const Octicon = item.fields.icon ? getPrimerIcon(item.fields.icon) : undefined
    return (
      <SupportGrid.Item key={item.sys.id} index={index} total={items.length}>
        <Pillar style={{flex: 1}}>
          {Octicon && <Pillar.Icon icon={<Octicon />} />}
          {item.fields.heading && <Pillar.Heading>{renderWithoutParagraphs(item.fields.heading)}</Pillar.Heading>}
          {item.fields.description && (
            <Pillar.Description>{renderWithoutParagraphs(item.fields.description)}</Pillar.Description>
          )}
        </Pillar>
      </SupportGrid.Item>
    )
  })
}
